<template>
    <div class="content">
        <p class="title" v-if="isFirstCreate">{{value.title}}</p>
        <div ref="echart" class="echart"></div>
    </div>
</template>

<script>
import {mixinCreateEchart} from '../mixins/createEchart'

export default {
  name: 'areaBaseic',
  mixins: [mixinCreateEchart],
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    colorOption: {
      type: String,
      default: '#67D6B1'
    },
    colorStops: {
      type: Array,
      default () {
        return [
          {offset: 0, color: '#fff'},
          {offset: 1, color: '#67D6B1'}
        ]
      }
    },
    axisLabel: {
      type: Object,
      default () {
        return {}
      }
    },
    gridTop: {
      type: String | Number,
      default: 50
    }
  },
  data () {
    return {
      echart: null,
      option: {
        color: '',
        grid: {
          top: this.gridTop,
          left: 10,
          right: 10,
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {color: '#909399'}
          },
          axisTick: {
            show: false
          },
          nameTextStyle: {
            fontSize: 11
          },
          data: [],
          axisLabel: {}
        },
        yAxis: {
          type: 'value',
          nameGap: 5,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#909399',
            formatter: function (value, index) {
              if ((index % 2) === 0) {
                return value
              } else if (isNaN(index)) {
                return value
              } else {
                return ''
              }
            }
          },
          axisLine: {
            lineStyle: {color: '#909399'}
          },
          axisTick: {
            show: false
          },
          nameTextStyle: {
            fontSize: 11
          }
        },
        series: [{
          data: [],
          type: 'line',
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: []
            },
            origin: 'start'
          }
        }]
      }
    }
  },
  methods: {
    changeEchart () {
      if (!this.value.series || !this.value.series.length) {
        this.echart.showLoading('nodatas')
      }
      this.echart.setOption({
        color: this.colorOption,
        xAxis: {
          axisLabel: this.axisLabel,
          data: this.value.xAxis
        },
        series: [{
          data: this.value.series,
          areaStyle: {
            color: {
              colorStops: this.colorStops
            }
          }
        }],
        yAxis: {
          name: this.value.name
        }
      })
    }
  }
}
</script>

<style  lang="scss" scoped>
    .content {
        position: relative;
    }

    .echart {
        width: 100%;
        height: 100%;
    }

    .title {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        color: #aaa;
    }


    .title {
        top: 10px;
        color: #303133;
        width: 100%;
        text-align: center;
    }
</style>
